export const GET_CONFIG_COLOR = "GET_CONFIG_COLOR";
export const SET_CONFIG_COLOR = "SET_CONFIG_COLOR";
